import api from "./api";

async function getInstitutions(type) {
  try {
    const response = await api.get(
      `api/institutions?type=${type}`
    );
    return response.data;
  } catch (error) {
    return [];
  }
}

export {
  getInstitutions
}